export function getLinkType(linkType: string | undefined) {
  switch (linkType) {
    case 'primary-button-white':
      return 'Button Button--primary Button--reversed'
    case 'primary-button-blue':
      return 'Button Button--primary'
    case 'primary-external-button':
      return 'Button Button--secondary Link--external'
    case 'secondary-button':
      return 'Button Button--secondary'
    case 'secondary-external-button':
      return 'Button Button--secondary Link--external'
    case 'tertiary-button-blue':
      return 'Button Button--tertiary'
    case 'tertiary-button-white':
      return 'Button Button--tertiary Button--reversed'
    case 'phone':
      return 'Link Link--currentColor u-padding1gu'
    default:
      return 'Button Button--secondary Button--actionblue Button--reversed'
  }
}

export function buttonType(type: string | undefined) {
  switch (type) {
    case 'primary':
      return 'Button Button--primary'
    case 'secondary':
      return 'Button Button--secondary'
    case 'tertiary':
      return 'Button Button--tertiary'
    case 'delete':
      return 'Button Button--delete'
    case 'icon':
      return 'Button Button--icon'
    case 'link':
      return 'Link'
    case 'primary-button-white':
      return 'Button Button--primary Button--reversed'
    case 'primary-button-blue':
      return 'Button Button--primary'
    case 'primary-external-button':
      return 'Button Button--secondary Link--external'
    case 'secondary-button':
      return 'Button Button--secondary'
    case 'secondary-external-button':
      return 'Button Button--secondary Link--external'
    case 'tertiary-button-blue':
      return 'Button Button--tertiary'
    case 'tertiary-button-white':
      return 'Button Button--tertiary Button--reversed'
    case 'phone':
      return 'Link Link--currentColor u-padding1gu'
    default:
      return 'Button Button--secondary Button--actionblue Button--reversed'
  }
}
